import "core-js/modules/es.array.push.js";
import axios from 'axios';
import { message } from 'ant-design-vue';
import qs from 'qs';
import store from '@/store';
import { cryptoEncrypt, cryptoDecrypt } from './aes';
import { removeCache } from '@/utils/session';
import router from '@/router';
let urls = 'admin/order/download,admin/policy/export,admin/policy/personnel-details-record/export,admin/order/order-payment-download,admin/company/workers/zip,upload/stream,admin/claims/zip,admin/policy/zip,admin/policy/export-zip,admin/customer-insurance/generate_qr_code,admin/policy/personnel-details/export,admin/policy/correct-record/personnel-export,admin/policy/correct-record/export';
let urls2 = 'admin/contract/store,admin/contract/edit,admin/company/workers/base-store,admin/company/workers/base-edit,admin/company/workers/certificate-edit,admin/auth/user-login,admin/v2/insurance-attach-plan/store,admin/v2/insurance-attach-plan/edit,admin/v2/insurance-attach/store,admin/v2/insurance-attach/edit';
//url3为需要返回整个response的接口
let urls3 = 'admin/policy/personnel-details/export,admin/policy/personnel-details-record/endorsement-export';
const service = axios.create({
  // baseURL: process.env.VUE_APP_BASE_API,
  baseURL: `/api`,
  timeout: 50000 // 请求超时时间
});
//请求
service.interceptors.request.use(config => {
  // config.headers['Content-Type'] = 'application/json'
  /**
   * @description 不需要token的接口
   * admin/system-config/detail、admin/system-config/resourse
   */
  if (config.url != 'admin/system-config/detail' || config.url != 'admin/system-config/resourse') {
    if (store.getters.token) {
      config.headers['Authorization'] = 'bearer ' + store.getters.token;
    }
  }
  if (config.url == 'send/sms' || config.url == 'send/sms-verify') {
    config.headers['X-Dispatch'] = 'Send';
    config.headers['X-Version'] = 'v1';
  }
  if (config.url == 'upload/tracback') {
    config.headers['X-Dispatch'] = 'Upload';
    config.headers['X-Version'] = 'upload';
  }
  if (process.env.NODE_ENV === 'production' && config.url !== 'upload/tracback') {
    config.headers['Content-Type'] = 'application/x-www-form-urlencoded';
  } else {
    config.headers['Content-Type'] = 'application/json';
  }
  if (urls.indexOf(config.url) > -1 || urls3.indexOf(config.url) > -1) {
    config.responseType = 'blob';
  }
  if (config.url == 'upload/stream') {
    config.headers['X-Dispatch'] = 'Upload';
    config.headers['X-Version'] = 'upload';
    config.headers['Content-Type'] = 'application/x-www-form-urlencoded';
  }
  return config;
});
const logout = async () => {
  await store.dispatch('user/logout');
  clearInterval();
  await store.dispatch('tagsView/clearTag');
  router.replace({
    path: '/login'
  });
  sessionStorage.removeItem('loginTime');
  sessionStorage.removeItem('loginRandomId');
};

//响应
service.interceptors.response.use(response => {
  if (response.data && response.data.code === 400006) {
    logout(); //账号登录失效或账号被删除后退出登录
    return;
  }
  var token = response.headers.authorization;
  if (token) {
    store.dispatch('user/setToken', token.split(' ')[1]).then(() => {});
  }
  const data = response.data;
  if (urls3.indexOf(response.config.url) > -1) {
    return Promise.resolve(response);
  } else if (urls.indexOf(response.config.url) > -1) {
    return Promise.resolve(data);
  } else if (urls2.indexOf(response.config.url) > -1) {
    return Promise.resolve(data);
  } else if (data.code === 200) {
    return Promise.resolve(data);
  } else {
    message.destroy();
    message.error(window.vm.$i18n.t(response.data.message) || '');
    console.log(response.data.message);
    if (response.data.code == 500002 || response.data.code == 500003) {
      store.dispatch('user/logout');
      // removeCache('TOKEN');
      router.push({
        name: 'login'
      });
    } else {
      return Promise.reject(response);
    }
  }
}, error => {
  console.log(444, error.response);
  if (urls2.indexOf(error.response.config.url) > -1) {
    return Promise.resolve(error.response.data);
  } else {
    message.destroy();
    message.error(window.vm.$i18n.t(error.response.data.message) || '');
    console.log(error.response.data.message);
    return Promise.reject(error.response);
  }

  // console.log(error.response.data)
});
let http = {};

/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */

http.get = function (url, params = null) {
  return new Promise((resolve, reject) => {
    service.get(url, {
      params
    }).then(res => {
      resolve(res.data);
    }).catch(e => {
      reject(e);
    });
  });
};

/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */

http.post = function (url, paramsObj, type) {
  let params = {
    timestamp: Math.round(new Date().getTime() / 1000).toString(),
    data: paramsObj
  };
  if (url == 'upload/stream') {
    params = qs.stringify(paramsObj);
  } else if (url == 'upload/tracback' || url == 'upload/file') {
    params = paramsObj;
  } else {
    if (process.env.NODE_ENV === 'production') {
      params.data.timestamp = params.timestamp;
      params.data = cryptoEncrypt(JSON.stringify(params.data));
      params = qs.stringify(params);
    } else {
      params.data.timestamp = params.timestamp;
    }
  }
  // console.log(url, paramsObj,params,process.env.NODE_ENV);
  return new Promise((resolve, reject) => {
    service.post(url, params, type).then(res => {
      if (urls.indexOf(url) > -1) {
        resolve(res);
      } else if (urls2.indexOf(url) > -1) {
        // if (res.code == 200) {
        if (process.env.NODE_ENV === 'production') {
          if (res.code == 200) {
            resolve({
              code: 200,
              data: cryptoDecrypt(res.data)
            });
          } else {
            resolve(res);
          }
        } else {
          resolve(res);
        }
        //   if (process.env.NODE_ENV === 'production') {
        //     resolve({code:200,data:cryptoDecrypt (res.data)});
        //   }else{
        //     resolve(res);
        //   }
        // } else {
        //   // message.error(res.message || '');
        //   // resolve(res);

        // }
      } else if (urls3.indexOf(url) > -1) {
        resolve(res);
      } else {
        if (process.env.NODE_ENV === 'production') {
          resolve(cryptoDecrypt(res.data));
        } else {
          // console.log(res, 'jkdkdldldlldldl');
          resolve(res.data);
        }
      }
      // resolve(cryptoDecrypt(res.data));
    }).catch(e => {
      reject(e);
    });
  });
};
export default http;